import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App.jsx"
import "./style.css"

const root = document.getElementById("app") || document.body.appendChild(document.createElement("div"))
root.id = "app"

createRoot(root).render(<App />)
